export enum MCFCostCenter {
    None = "None",
    MCFA = "MCFA",
    MCFE = "MCFE",
    MCFS = "MCFS",
}
